<template>
  <avs-card>
    <template v-slot:title>
      {{ $tc("Espace Evenementiel") }}
      <div class="d-flex justify-space-between gap-4">
        <avs-button
          text
          color="accent"
          :to="{ name: 'Projects' }"
          :spantext="
            $t('actions.see', {
              entity: $t('commons.all', {
                entity: $tc('categories.project.name', 2).toLowerCase()
              }).toLowerCase()
            })
          "
        >
          <template v-slot:name>
            {{ $t("actions.see", { entity: $t("commons.all", { entity: "" }).toLowerCase() }) }}
          </template>
        </avs-button>
        <avs-createButton
          v-if="canCreate"
          :to="{ name: 'ProjectCreateUpdate' }"
          :spantext="$t('Nouvel Espace')"
          :name="$t('Nouvel Espace')"
        >
        </avs-createButton>
      </div>
    </template>
    <template v-slot:content>
      <v-card-text v-if="!isEmpty">
        <avs-list>
          <v-list-item-group>
            <avs-card
              outlined
              class="mb-2 p-1"
              :rounded="false"
              subtitle
              v-for="(project, idx) in dataset"
              :key="idx"
              @click="handleItemClick(project)"
            >
              <template v-slot:title>
                <span class="pb-0 pl-0 pt-0 primary--text text-h6 font-weight-bold">{{
                  project.name
                }}</span>
              </template>

              <template v-slot:subtitle>
                <v-card-subtitle class="pb-0 pl-0 pt-0 font-weight-bold">
                  {{ project.company.name }}
                </v-card-subtitle>
              </template>
              <template v-slot:content>
                <v-card-actions>
                  <avs-chip
                    class="mr-4"
                    text-color="primary"
                    icon="mdi-calendar-text-outline"
                    >{{ $t("Clients") }} ({{ project.customers }})
                  </avs-chip>

                  <avs-chip
                    text-color="primary"
                    icon="mdi-calendar-text-outline"
                    >{{ $tc("Reservation à venir", 2) }} ({{ project.remaining_reservation }})
                  </avs-chip>
                </v-card-actions>
              </template>
            </avs-card>
          </v-list-item-group>
        </avs-list>
      </v-card-text>

      <v-card-text v-else>{{ $t("messages.information.no_project") }}</v-card-text>
    </template>
  </avs-card>
</template>

<script>
export default {
  name: "ProjectList",
  components: {
    AvsList: () => import("@/components/generics/general/AvsList.vue")
  },
  props: {
    projects: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: 0
    }
  },
  computed: {
    canCreate() {
      return this.$store.getters["app/canCreateProject"]
    },
    dataset() {
      return this.maxLength > 0 ? this.projects.slice(0, this.maxLength) : this.projects
    },
    isEmpty() {
      return this.projects.length <= 0
    }
  },
  methods: {
    handleItemClick(item) {
      this.$store.commit("app/setProject", item)
      this.$store.commit("app/setCompany", item.company)
      this.$router.push({ name: "Project" })
    },
    isOverdue(project) {
      return project.progression > 100
    }
  }
}
</script>
